// @mui material components
import React, { useState,useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Card from "@mui/material/Card";
import Table from 'react-bootstrap/Table';
import { ThreeDots } from 'react-loader-spinner';
import TableContainer from "@mui/material/TableContainer";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import XLSX from 'sheetjs-style';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Drop from "../../assets/images/upload.png";
import typography from "assets/theme/base/typography";
import { ToastContainer, toast } from 'react-toastify';
const { size } = typography;
import VisibilityIcon from '@mui/icons-material/Visibility';
// Soft UI Dashboard React components
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftSelect from "components/SoftSelect";
import Grid from "@mui/material/Grid";
import 'index.css';
import * as FileSaver from 'file-saver';
import Icon from '@mui/material/Icon';
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import alasql from "alasql";
import SoftButton from "components/SoftButton";
import { useDropzone } from "react-dropzone";
//import Table from "examples/Tables/Table";
//import DataTable from "examples/Tables/DataTable";
import { authDistributionChannel,authSalesOfficeGroupMapping,fileUpload,authGeoMapping,authUpdateCustomer,authSalesOrganization,authTermsofPayment,authAccountAssignmentGroup,authIndustryCode,authShippingCondition,authSalesOffice,authPartnerFunction,authSalesDistrict,authCompanyCode,authReconAccount,authRegion,authDivision,authGoodsTAX,authGetCustomer,authGetCustomerDetails,authSaveApprovalStatus,authCustomerSearch, authAccountGroup } from '../../assets/globalAPI/GlobalApi';
function CustomerList() {
  var offset = 20;
  var offset2 = 1;
  
  const fileExtension = '.xlsx';
  const toastId = React.useRef(null);
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8';
  const[accountGroup,setAccountGroup] = useState({});
  const[selectedAccountGroup,setSelectedAccountGroup] = useState('');
  const[selectComment,setselectComment] = useState('');
  const [loaderspinner, setLoaderSpinner] = useState(false);
  const[selectName1,setselectName1] = useState('');
  const[selectName2,setselectName2] = useState('');
  const[selectName3,setselectName3] = useState('');
  const[selectName4,setselectName4] = useState('');
  const[statusSort,setStatusSort] = useState('');
  const[selectSerachTerm,setselectSerachTerm] = useState('');
  const[selectStreet2,setselectStreet2] = useState('');
  const[selectStreet3,setselectStreet3] = useState('');
  const[selectIndustryKey,setselectIndustryKey] = useState('');
  const[selectIndustryCode,setselectIndustryCode] = useState('');
  const[selectPostalCode,setselectPostalCode] = useState('');
  const[selectTelephone,setselectTelephone] = useState('');
  const[selectMobile,setselectMobile] = useState('');
  const[selectFAX,setselectFAX] = useState('');
  const[selectEmail,setselectEmail] = useState('');
  const[totalCount,setTotalCount] = useState('');
  const[selectPAN,setselectPAN] = useState('');
  const[selectPANReference,setselectPANReference] = useState('');
  const[selectGSTN,setselectGSTN] = useState('');
  const[selectVendorCode,setselectVendorCode] = useState('');
  const [customerStatisticGroup, setcustomerStatisticGroup] = useState({});
  const [attribute1Options, setattribute1Options] = useState({});
  const [attribute2Options, setattribute2Options] = useState({});
  const [territoryCode, setTerritoryCode] = useState({});
  const [taxClassification1Option, settaxClassification1Option] = useState({});
  const [taxClassification2Option, settaxClassification2Option] = useState({});
  const [taxClassification3Option, settaxClassification3Option] = useState({});
  const [taxClassification4Option, settaxClassification4Option] = useState({});
  const [taxClassification6Option, settaxClassification6Option] = useState({});
  const [pricingProcedure, setpricingProcedure] = useState({});
  const [creditControl, setcreditControl] = useState({});
  const [sortStatusValue, setSortStatusValue] = useState([{ value: '', label: 'Choose Status' }]);
  const [cusAcctGrpValue, setCusAcctGrpValue] = useState([{ value: '', label: 'Customer Account Group' }]);
  const[selectEP,setselectEP] = useState('');
  const[selectIP,setselectIP] = useState('');
  const [paymentkey, setpaymentkey] = useState({});
  const [incoterms1, setincoterms1] = useState({});
  const [incoterms2, setincoterms2] = useState({});
  const [salesGrp, setsalesGrp] = useState({});
  const [reconAcc, setreconAcc] = useState({});
  const [street, setStreet] = useState({});
  const [city1, setCity1] = useState({});
  const [franchiseTypeSelect, setfranchiseTypeSelect] = useState({});
  const [city2, setCity2] = useState({});
  const[selectAssignmentGroup,setselectAssignmentGroup] = useState('');
  const[selectCustomerStatisticGroup,setSelectCustomerStatisticGroup] = useState('');
  const[accountGroupValue,setAccountGroupValue] = useState('');
  const[accGroup,setAccGroup] = useState({});
const[companyCode,setCompanyCode] = useState({});
const[selectedCompanyCode,setSelectedCompanyCode] = useState('');
const[companyCodeValue,setCompanyCodeValue] = useState('');
const[comCode,setcomCode] = useState({});
const[salesOrganization,setSalesOrganization] = useState({});
const[selectSalesOrganization,setSelectSalesOrganization] = useState('');
const[selectShippingCondition,setselectShippingCondition] = useState('');
const[salesOrganizationValue,setSalesOrganizationValue] = useState('');
const[seletStreet,setseletStreet] = useState('');
const[salesOrg,setSalesOrg] = useState({});
const[currentCustomerList,setCurrentCustomerList] = useState({});
const[distributionChannel,setDistributionChannel] = useState({});
const[selectDistributionChannel,setselectDistributionChannel] = useState('');
const[distributionChannelValue,setDistributionChannelValue] = useState('');
const[discChannel,setDiscChannel] = useState({});
const[division,setDivision] = useState({});
const[franchiseType,setfranchiseType] = useState({});
const[selectDivition,setSelectDivition] = useState('');
const[selectGoodTAX,setSelectGoodTAX] = useState('');
const[divisionValue,setDivisionValue] = useState('');
const[goodTAXValue,setGoodTAXValue] = useState('');
const[divitionEdited,setDivitionEdited] = useState({});
const[goodtaxEdited,setgoodtaxEdited] = useState({});
const[region,Setregion] = useState({});
const[selectRegion,setSelectRegion] = useState('');
const[regionValue,setRegionValue] = useState('');
const[regionEdited,setRegionEdited] = useState({});
const[reaconAccount,setReaconAccount] = useState({});
const[selectReconAccount,setSelectReconAccount] = useState('');
const[reconValue,setReconValue] = useState('');
const[cityValue,setCityValue] = useState('');
const[districtValue,setDistrictValue] = useState('');
const[reconAccountEdited,setReconAccountEdited] = useState({});
const[salesDistrict,setSalesDistrict] = useState({});
const[selectsalesDistrict,setSelectsalesDistrict] = useState('');
const[salesDistrictValue,setSalesDistrictValue] = useState('');
const[salesDistrictValueEdited,setSalesDistrictValueEdited] = useState({});
const[salesOffice,setSalesOffice] = useState({});
const[selectSalesOffice,setSelectSalesOffice] = useState('');
const[salesOfficeValue,setSalesOfficeValue] = useState('');
const[salesOfficeValueEdited,setSalesOfficeValueEdited] = useState({});
const[shippingConsitionEdited,setShippingConsitionEdited] = useState({});
const[accountAssignemntEdited,setaccountAssignemntEdited] = useState({});
const[industryCodeEdited,setIndustryCodeEdited] = useState({});
const[attribute1value,setAttribute1Value] = useState('');
const[attribute2value,setAttribute2Value] = useState('');
const[salesGroupValue,setSalesGroupValue] = useState('');
const[pricingProcedureValue,setPricingProcedureValue] = useState('');
const[customerStatisticValue,setCustomerStatisticValue] = useState('');
const[shippingConditionValue,setShippingConditionValue] = useState('');
const[accountAssignmentvalue,setaccountAssignmentvalue] = useState('');
const[incoterms1Value,setIncoterms1Value] = useState('');
const[paymentKeyValue,setPaymentKeyValue] = useState('');
const[creditControlValue,setcreditControlValue] = useState('');
const[incoterms2Value,setIncoterms2Value] = useState('');
const[taxCollection1,setTaxCollection1] = useState('');
const[taxCollection2,setTaxCollection2] = useState('');
const[taxCollection3,setTaxCollection3] = useState('');
const[taxCollection4,setTaxCollection4] = useState('');
const[taxCollection5,setTaxCollection5] = useState('');
const[taxCollection6,setTaxCollection6] = useState('');
const[partnerFunctionValue,setPartnerFunctionValue] = useState('');
const[goodstax,setGoodsTAX] = useState({});
const[termsPayment,setTermsPayment] = useState({});
const[salesGroup,setSalesGroup] = useState({});
const[shippingCon,setShippingCon] = useState({});
const[partnerFunction,setPartnerFunction] = useState({});
const[industryCode,setIndustryCode] = useState({});
const[accountAssignmentGroup,setAccountAssignmentGroup] = useState({});
  const [search, setSearch] = useState("");
  const [search2, setSearch2] = useState("");
  const [withFilter, setWithFilter] = useState("");
  const navigate = useNavigate();
  const [curpage, setcurPage] = useState(1);
  const [nofopage, setNofopage] = useState(1);
  const[userAccess,setUserAccess] = useState('');
  const[userEmail,setUserEmail] = useState('');
  const[userID,setUserID] = useState('');
  const[userid,setUser_ID] = useState('');
  const[userName,setUserName] = useState('');
  const[cusid,setcusid] = useState('');
  const[customerlist,setCustomerList] = useState([]);
  const[customerlistfilter,setCustomerListFilter] = useState([]);
  const[customerDetails,setCustomerDetails] = useState([]);
  const[PANFiles,setPANFiles] = useState([]);
  const[GSTNFiles,setGSTNFiles] = useState([]);
  const[OtherFiles,setOtherFiles] = useState([]);
  const[approval,setApproval] = useState('');
  const [lgShow, setLgShow] = useState(false);
  const [lgApproveShow, setlgApproveShow] = useState(false);
  const [lgEditShow, setEditLgShow] = useState(false);
  const [show1, setShow] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState('');
  const [customerid, setcustomerid] = useState('');
  const [dc, setDC] = useState('');
  const [searchParams] = useSearchParams();
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({});
  const [state, setState] = useState({
    email: "",
    comment: ""
  });
  const { getRootProps: getRootfileProps, getInputProps: getInputfileProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFile) => {
      setFile(
        Object.assign(acceptedFile[0], {
          preview: URL.createObjectURL(acceptedFile[0]),
        }),
      );
    },
  });
  useEffect(() => {
    if (localStorage.getItem('userid_details')) { 
      setLoaderSpinner(true);
      let session = localStorage.getItem('userid_details');
      let userid_array =JSON.parse(session);
      let userid = userid_array.userid;
      let user_id = userid_array.id;
      let user_type = userid_array.user_type;
      let user_email = userid_array.email;
      let user_name = userid_array.name;
      setUserAccess(user_type);
      setUserID(userid);
      setUserEmail(user_email);
      setUser_ID(user_id);
      setUserName(user_name);
      let id = searchParams.get('id');
      let approver_username = searchParams.get('userid');
      if(search2=='' && withFilter=='' && statusSort=='')
      {
        const data = {
          "action": 'getCustomer',
          "userid" : userid,
          "user_id" : user_id,
          "user_type" : user_type
        };
        console.log(JSON.stringify(data));
        authGetCustomer(JSON.stringify(data)).then(function(response) {
        var res = response.data;
       //console.log(res);
          if(res.status=='true' && res.code=='200')
          {
            setLoaderSpinner(false);
            setTotalCount(res.count);
            var resdata = res.customer_details;
            setCurrentCustomerList(resdata);
            setNofopage(Math.ceil(resdata.length / offset));
            var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;
            var arraydata = alasql(text, [resdata]);
            setCustomerList(arraydata);
            if(id!=null)
            {
            viewCustomerDetails(id,'Pending',userAccess,'');
            }
          }else{
            setTotalCount(res.count);
            setLoaderSpinner(false);
            setCustomerList(res.customer_details);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      }else if(search2!='' && withFilter!='' && statusSort==''){
        fetchFilterData2();
      }else if(search2=='' && withFilter!='' && statusSort!=''){
        fetchFilterData3();
      }else{

      }
      }else{
        // navigate('/');
      }
      
  },[userID,userAccess,curpage]);
  const getData = async (id) => {
    const data1 = {
      "action": 'getCustomerFullDetails',
      "id": id
    };
   await authGetCustomerDetails(JSON.stringify(data1)).then(function(response) {
      var res = response.data;
        if(res.status=='true' && res.code=='200')
        {
          setLgShow(true);
          setCustomerDetails(res.customer_details);
          setPANFiles(res.customer_details.pan_files);
          setGSTNFiles(res.customer_details.gstn_files);
          setOtherFiles(res.customer_details.other_files);
        }else{  
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });
    
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState((prevProps) => ({
      ...prevProps,
      [name]: value
    }));
  };
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  const handleSubmit = (event) => {
    event.preventDefault();
    let session = localStorage.getItem('userid_details');
    let userid_array =JSON.parse(session);
    let userid = userid_array.userid;
    let user_id = userid_array.id;
    state['action'] = 'saveApproval';
    state['email'] = document.getElementById('email').value;
    state['status'] = approvalStatus;
    state['customerid'] = customerid;
    state['userid'] = userid;
    state['user_id'] = user_id;
    state['dc'] = dc;
    console.log(JSON.stringify(state));
    authSaveApprovalStatus(JSON.stringify(state)).then(function(response) {
      var res = response.data;
        //console.log(res);
        if(res.status=='true' && res.code=='200')
        {
          if(! toast.isActive(toastId.current)) {
            toastId.current = toast.success("Save successfully!");  
          }
         
          const data = {
            "action": 'getCustomer',
            "userid" : userID,
            "user_id" : user_id,
            "user_type" : userAccess
          };
          
          authGetCustomer(JSON.stringify(data)).then(function(response) {
          var res = response.data;
          
            if(res.status=='true' && res.code=='200')
            {
              var resdata = res.customer_details;
              setNofopage(Math.ceil(resdata.length / offset));
              var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;
              
              var arraydata = alasql(text, [resdata]);
              
              setlgApproveShow(false);
              setLgShow(false);
              setShow(false);
              setCustomerList(arraydata);
            }else{
              setCustomerList(res.customer_details);
          }
          }.bind(this)
        )
        .catch(function(error) {
        console.log(error);
        });
        }else{
          
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });
  };
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const approveHandle = async (id,dc,status) => {
    setShow(true);
    setApprovalStatus(status);
    setcustomerid(id);
    setDC(dc);
  }
  const updateCustomer = async (id,request_id) => {
    setLoaderSpinner(true);
    let country = document.getElementById('country').value;
    let language = document.getElementById('language').value;
    let indicator = 'X';
    let company_code = selectedCompanyCode;
    let sales_organization = selectSalesOrganization;
    let distribution_channel = selectDistributionChannel;
    let division = selectDivition;
    let customer_account_group = selectedAccountGroup;
    let region = regionValue;
    let sales_district = selectsalesDistrict;
    let sales_office = selectSalesOffice;
    let sales_group = salesGroupValue;
    let shipping_condition = selectShippingCondition;
    let account_assignment_group = selectAssignmentGroup;
    let street = seletStreet;
    let district = districtValue;
    let city = cityValue;
    let attribute1 = attribute1value;
    let attribute2 = attribute2value;
    let reconAccount =  reconValue;
    let pricing_procedure = pricingProcedureValue;
    let customer_statistic_group = customerStatisticValue;
    let incoterms1 = incoterms1Value;
    let incoterms2 = incoterms2Value;
    let payment_key = paymentKeyValue;
    let credit_control = creditControlValue;
    let tax_classification1 = taxCollection1;
    let tax_classification2 = taxCollection2;
    let tax_classification3 = taxCollection3;
    let tax_classification4 = taxCollection4;
    let tax_classification5 = taxCollection5;
    let tax_classification6 = taxCollection6;
    let comment = selectComment;
    var other_document_arr = [];

    //Other document upload code
    try{
      for (let j = 0; j < acceptedFiles.length; j++) {

      var response3 =await fileUpload(acceptedFiles[j])
         
              var res3 = response3.data;
              
              if (res3 == 'no file found') {

                if (!toast.isActive(toastId.current)) {
                  toastId.current = toast.warning("File size exceeds 2 MB, all files may not be uplaoded successfully!");
                }

              } else {
                if (res3.code == "200" && res3.status == "true") {
                  
                  other_document_arr.push({
                    filename: res3.filename,
                    filepath: res3.filepath,
                  });
                  
                  
                } else {
                }
              }



      }
    }catch(error){
      console.log(error)
    }



    const data = {
      "action": 'edit_customer',
      "customer_id": id,
      "request_id": request_id,
      "initiator_id": userID,
      "initiator_email": userEmail,
      "initiator_name": userName,
      "customer_account_group": customer_account_group,
      "company_code": company_code,
      "sales_organization": sales_organization,
      "distribution_channel": distribution_channel,
      "division": division,
      "name1": selectName1,
      "name2": selectName2,
      "name3": selectName3,
      "name4": '',
      "search_term1": selectSerachTerm,
      "postal_code": selectPostalCode,
      "city": city,
      "district": district,
      "street": street,
      "street1": selectStreet2,
      "street2": selectStreet3,
      "country": country,
      "region": region,
      "language": language,
      "telephone": selectTelephone,
      "mobile": selectMobile,
      "fax": selectFAX,
      "email": selectEmail,
      "comment": comment,
      "attribute1": attribute1,
      "attribute2": attribute2,
      "pan": selectPAN,
      "pan_reference": selectPANReference,
      "adhar_pan_link": 1,
      "gstn": selectGSTN,
      "industry_key": selectIndustryKey,
      "industry_code1": selectIndustryCode,
      "general_ledger": reconAccount,
      "sales_district": sales_district,
      "sales_office": sales_office,
      "sales_group": sales_group,
      "currency": 'INR',
      "pricing_procedure": pricing_procedure,
      "customer_statistic_group": customer_statistic_group,
      "shipping_condition": shipping_condition,
      "indicator": indicator,
      "incoterms1": incoterms1,
      "incoterms2": incoterms2,
      "payment_key": payment_key,
      "credit_control_area": credit_control,
      "account_assignment_group": account_assignment_group,
      "tax_classification1": tax_classification1,
      "tax_classification2": tax_classification2,
      "tax_classification3": tax_classification3,
      "tax_classification4": tax_classification4,
      "tax_classification5": tax_classification5,
      "tax_classification6": tax_classification6,
      "ep": selectEP,
      "ip": selectIP,
      "business_partner": '',
      "vendor_code": selectVendorCode,
      "franchise_type" : franchiseType,
      "other_file_details": JSON.stringify(other_document_arr)
    }
   //console.log(JSON.stringify(data));
   authUpdateCustomer(JSON.stringify(data)).then(function(response) {
    var res = response.data;
      if(res.status=='true' && res.code=='200')
      {
        setLoaderSpinner(false);
        if(! toast.isActive(toastId.current)) {
          toastId.current = toast.success("Updated successfully!");  
        }
        setEditLgShow(false);
        const data = {
          "action": 'getCustomer',
          "userid" : userID,
          "user_id" : userid,
          "user_type" : userAccess
        };      
        authGetCustomer(JSON.stringify(data)).then(function(response) {
        var res = response.data;     
          if(res.status=='true' && res.code=='200')
          {
            var resdata = res.customer_details;
            setNofopage(Math.ceil(resdata.length / offset));
            var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;          
            var arraydata = alasql(text, [resdata]);
            setCustomerList(arraydata);
          }else{
            setCustomerList(res.customer_details);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
        
      }else{
        if(! toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Something went wrong,please try again!");
        }
        
    }
    }.bind(this)
  )
  .catch(function(error) {
  console.log(error);
  });
   
  }
  const fetchFilterData2 = async (e) => {
    setLoaderSpinner(true);
    setCustomerList([]);
    const data = {
      "action": 'accountGroupSearch',
      "account_group": search2,
      "userid" : userID,
      "user_id" : userid,
      "user_type" : userAccess
    };
    authCustomerSearch(JSON.stringify(data)).then(function(response) {
    var res = response.data;
    //console.log(JSON.stringify(res));
      if(res.status=='true' && res.code=='200')
      {
        setLoaderSpinner(false);
        setTotalCount(res.count);
        var resdata = res.customer_details;
        setCustomerListFilter(resdata);
        setCurrentCustomerList(resdata);
        setNofopage(Math.ceil(resdata.length / offset));
        //console.log(Math.ceil(resdata.length / offset));
        var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset; 
        var arraydata = alasql(text, [resdata]);
        setCustomerList(arraydata);
      }else{
        setLoaderSpinner(false);
        setTotalCount(res.count);
        setCustomerList(res.customer_details);
    }
    }.bind(this)
  )
  .catch(function(error) {
  console.log(error);
  });

  };
  const fetchFilterData = async (e) => {
  const data = {
    "action": 'getCustomer',
    "userid" : userID,
    "user_id" : userid,
    "user_type" : userAccess
  };
 
  authGetCustomer(JSON.stringify(data)).then(function(response) {
  var res = response.data;
 
    if(res.status=='true' && res.code=='200')
    {
      setLoaderSpinner(false);
     
      var resdata = res.customer_details;
     
      //console.log(JSON.stringify(resdata));
      var text = "select * from ? WHERE customer_number = ?";
      var arraydata = alasql(text,[resdata,search]);
      //console.log(arraydata);
      setCurrentCustomerList(arraydata);
      setNofopage(Math.ceil(arraydata.length / offset));
      var text1 = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;          
      var arraydata1 = alasql(text1, [arraydata]);
      setTotalCount(arraydata.length);
      setCustomerList(arraydata1);
    }else{
      setLoaderSpinner(false);
      setTotalCount(res.count);
      setCustomerList(res.customer_details);
  }
  }.bind(this)
)
.catch(function(error) {
console.log(error);
});

  };
  const filterData2 = () => {
    setSearch("");
    setStatusSort("");
    if (search2) {
      setWithFilter('1');
      setcurPage(1);
      fetchFilterData2();  
    }else{

      const data = {
        "action": 'getCustomer',
        "userid" : userID,
        "user_id" : userid,
        "user_type" : userAccess
      };
      
      authGetCustomer(JSON.stringify(data)).then(function(response) {
      var res = response.data;
     
        if(res.status=='true' && res.code=='200')
        {
          var resdata = res.customer_details;
          setCurrentCustomerList(resdata);
          setNofopage(Math.ceil(resdata.length / offset));
          var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;         
          var arraydata = alasql(text, [resdata]);
          setCustomerList(arraydata);
        }else{
          setCustomerList(res.customer_details);
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });
    }
  };
  const filterData3 = () => {
    setSearch("");
    setSearch2("");
    if (statusSort) {
      setWithFilter('1');
      setcurPage(1);
      fetchFilterData3();  
    }else{

      const data = {
        "action": 'getCustomer',
        "userid" : userID,
        "user_id" : userid,
        "user_type" : userAccess
      };
      
      authGetCustomer(JSON.stringify(data)).then(function(response) {
      var res = response.data;
     
        if(res.status=='true' && res.code=='200')
        {
          var resdata = res.customer_details;
          setCurrentCustomerList(resdata);
          setNofopage(Math.ceil(resdata.length / offset));
          var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;         
          var arraydata = alasql(text, [resdata]);
          setCustomerList(arraydata);
        }else{
          setCustomerList(res.customer_details);
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });
    }
  };
  const filterData = () => {
    setSearch2("");
    setStatusSort("");
    if (search) {
      fetchFilterData();  
    }else{

      const data = {
        "action": 'getCustomer',
        "userid" : userID,
        "user_id" : userid,
        "user_type" : userAccess
      };
      
      authGetCustomer(JSON.stringify(data)).then(function(response) {
      var res = response.data;
     
        if(res.status=='true' && res.code=='200')
        {
          var resdata = res.customer_details;
          setCurrentCustomerList(resdata);
          setNofopage(Math.ceil(resdata.length / offset));
          var text = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;
          
          var arraydata = alasql(text, [resdata]);
         
  
          setCustomerList(arraydata);
        }else{
          setCustomerList(res.customer_details);
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });



    }
  };
  const viewCustomerDetails = async (id,status,user_type,initiator_status) => {
   
    const data = {
      "action": 'getCustomerFullDetails',
      "id": id
    };
     await authGetCustomerDetails(JSON.stringify(data)).then(function(response) {
      var res = response.data;
      
        if(res.status=='true' && res.code=='200')
        {
         
          setCustomerDetails(res.customer_details);
          setPANFiles(res.customer_details.pan_files);
          setGSTNFiles(res.customer_details.gstn_files);
          setOtherFiles(res.customer_details.other_files);

              var customerAccGrp = res.customer_details.customer_account_group;
              var companyCode = res.customer_details.company_code;
              var salesOrganization = res.customer_details.sales_organization;
              var distributionChannel = res.customer_details.distribution_channel;
              var division = res.customer_details.division;
              var region = res.customer_details.region;
              var attribute1 = res.customer_details.attribute1;
              var attribute2 = res.customer_details.attribute2;
              var recon_account = res.customer_details.general_ledger;
              var sales_district = res.customer_details.sales_district;
              var sales_office = res.customer_details.sales_office;
              var sales_group = res.customer_details.sales_group;
              var pricing_procedure = res.customer_details.pricing_procedure;
              var customer_statistic_group = res.customer_details.customer_statistic_group;
              var shipping_condition = res.customer_details.shipping_condition;
              var account_assignment_group = res.customer_details.account_assignment_group;
              var incoterms1 = res.customer_details.incoterms1;
              var incoterms2 = res.customer_details.incoterms2;
              var payment_key = res.customer_details.payment_key;
              var tax_classification1 = res.customer_details.tax_classification1;
              var tax_classification2 = res.customer_details.tax_classification2;
              var tax_classification3 = res.customer_details.tax_classification3;
              var tax_classification4 = res.customer_details.tax_classification4;
              var tax_classification5 = res.customer_details.tax_classification5;
              var tax_classification6 = res.customer_details.tax_classification6;
              var industry_code1 = res.customer_details.industry_code1;
              var street = res.customer_details.street;
              var district = res.customer_details.district;
              var city = res.customer_details.city;
              var credit_control = res.customer_details.credit_control;
              var comment = res.customer_details.comment;
              var name1 = res.customer_details.name1;
              var name2 = res.customer_details.name2;
              var name3 = res.customer_details.name3;
              var name4 = res.customer_details.name4;
              var ep = res.customer_details.ep;
              var ip = res.customer_details.ip;
              var search_term1 = res.customer_details.search_term1;
              var street2 = res.customer_details.street1;
              var street3 = res.customer_details.street2;
              var postal_code = res.customer_details.postal_code;
              var telephone = res.customer_details.telephone;
              var mobile = res.customer_details.mobile;
              var fax = res.customer_details.fax;
              var email = res.customer_details.email;
              var pan = res.customer_details.pan;
              var pan_reference = res.customer_details.pan_reference;
              var gstn = res.customer_details.gstn;
              var vendor_code = res.customer_details.vendor_code;
              var industry_key = res.customer_details.industry_key;
              var franchise_type = res.customer_details.franchise_type;
              setselectName1(name1);
              setselectName2(name2);
              setselectName3(name3);
              setselectName4(name4);
              setselectSerachTerm(search_term1);
              setselectStreet2(street2);
              setselectStreet3(street3);
              setselectPostalCode(postal_code);
              setselectTelephone(telephone);
              setselectMobile(mobile);
              setselectFAX(fax);
              setselectEmail(email);
              setselectPAN(pan);
              setselectPANReference(pan_reference);
              setselectGSTN(gstn);
              setselectVendorCode(vendor_code);
              setselectIndustryKey(industry_key);
              setselectIndustryCode(industry_code1);
              setselectEP(ep);
              setselectIP(ip);
              setselectComment(comment);
              setSelectedAccountGroup(customerAccGrp);
              setSelectedCompanyCode(companyCode);
              setSelectSalesOrganization(salesOrganization);
              setselectDistributionChannel(distributionChannel);
              setSelectDivition(division);
              setRegionValue(region);
              setAttribute1Value(attribute1);
              setAttribute2Value(attribute2);
              setReconValue(recon_account);
              setSelectsalesDistrict(sales_district);
              setSelectSalesOffice(sales_office);
              setSalesGroupValue(sales_group);
              setPricingProcedureValue(pricing_procedure);
              setCustomerStatisticValue(customer_statistic_group);
              setselectShippingCondition(shipping_condition);
              setselectAssignmentGroup(account_assignment_group);
              setIncoterms1Value(incoterms1);
              setIncoterms2Value(incoterms2);
              setPaymentKeyValue(payment_key);
              setTaxCollection1(tax_classification1);
              setTaxCollection2(tax_classification2);
              setTaxCollection3(tax_classification3);
              setTaxCollection4(tax_classification4);
              setTaxCollection5(tax_classification5);
              setTaxCollection6(tax_classification6);
              setseletStreet(street);
              setCityValue(city);
              setDistrictValue(district);
              setcreditControlValue(credit_control);
              setfranchiseType(franchise_type);

              var franchiseTypeValue = [
                { value: res.customer_details.franchise_type, label: res.customer_details.franchise_type }
              ];
              setfranchiseTypeSelect(franchiseTypeValue);

              var cityValue = [
                { value: res.customer_details.city, label: res.customer_details.city }
              ];
              setCity1(cityValue);

              var districtValue = [
                { value: res.customer_details.district, label: res.customer_details.district }
              ];
              setCity2(districtValue);

              var streetValue = [
                { value: res.customer_details.street, label: res.customer_details.street }
              ];
              setStreet(streetValue);

              var salesFroupvalue = [
                { value: res.customer_details.sales_group, label: res.customer_details.sales_group }
              ];
              setsalesGrp(salesFroupvalue);
              var reconAccountValue = [
                { value: res.customer_details.general_ledger, label: res.customer_details.general_ledger }
              ];
              setreconAcc(reconAccountValue);

              var incoterms1value = [
                { value: res.customer_details.incoterms1, label: res.customer_details.incoterms1 }
              ];
              setincoterms1(incoterms1value);
              var incoterms2value = [
                { value: res.customer_details.incoterms2, label: res.customer_details.incoterms2 }
              ];
              setincoterms2(incoterms2value);

              var paymentkeyvalue = [
                { value: res.customer_details.payment_key, label: res.customer_details.payment_key }
              ];
              setpaymentkey(paymentkeyvalue);

              var creditControlvalue = [
                { value: res.customer_details.credit_control, label: res.customer_details.credit_control }
              ];
              setcreditControl(creditControlvalue);

              var pricingProcedureValue = [
                { value: res.customer_details.pricing_procedure, label: res.customer_details.pricing_procedure }
              ];
              setpricingProcedure(pricingProcedureValue);

              var customerStatisticGroup = [
                { value: res.customer_details.customer_statistic_group, label: res.customer_details.customer_statistic_group }
              ];
              setcustomerStatisticGroup(customerStatisticGroup);

              var attribute1Options = [
                { value: res.customer_details.attribute1, label: res.customer_details.attribute1 }
              ];
              setattribute1Options(attribute1Options);

              var attribute2Options = [
                { value: res.customer_details.attribute2, label: res.customer_details.attribute2 }
              ];
              setattribute2Options(attribute2Options);

              var industryCodeValue = [
                { value: res.customer_details.industry_code1, label: res.customer_details.industry_code1 }
              ];
              setTerritoryCode(industryCodeValue);

              var trax_classification1 = [
                { value: res.customer_details.tax_classification1, label: res.customer_details.tax_classification1 }
              ];
              settaxClassification1Option(trax_classification1);
              var trax_classification2 = [
                { value: res.customer_details.tax_classification2, label: res.customer_details.tax_classification2 }
              ];
              settaxClassification2Option(trax_classification2);
              var trax_classification3 = [
                { value: res.customer_details.tax_classification3, label: res.customer_details.tax_classification3 }
              ];
              settaxClassification3Option(trax_classification3);
              var trax_classification4 = [
                { value: res.customer_details.tax_classification4, label: res.customer_details.tax_classification4 }
              ];
              settaxClassification4Option(trax_classification4);
              var trax_classification6 = [
                { value: res.customer_details.tax_classification6, label: res.customer_details.tax_classification6 }
              ];           
              settaxClassification6Option(trax_classification6);
          const group_data = {
            "action": 'account_group'
          };
          const data = {
            "action": 'distributionChannel'
          };
          const company_code_data = {
            "action": 'company_code'
          };
          const goods_tax_data = {
            "action": 'goods_tax'
          };
          const  recon_account_data = {
            "action": ' recon_account'
          };
          const division_data = {
            "action": 'division'
          };
          const region_data = {
            "action": 'region'
          };
          const sales_district_data = {
            "action": 'sales_district'
          };
          const sales_office_data = {
            "action": 'sales_office'
          };
          const terms_of_payment_data = {
            "action": 'terms_of_payment'
          };
          const industry_code_data = {
            "action": 'industry_code'
          };
        
          const account_assignment_group_data = {
            "action": 'account_assignment_group'
          };
          const shipping_condition_data = {
            "action": 'shipping_condition'
          };
         
          const sales_organization_data = {
            "action": 'sales_organization'
          };
       
          authGetCustomerDetails(JSON.stringify(sales_organization_data)).then(function(response) {
            var res = response.data;
           
              if(res.status=='true' && res.code=='200')
              {
                var data = res.array
             var filtered = data.filter((x)=>{return x.value===salesOrganization})
             setSalesOrg(filtered);
                setSalesOrganization(res.array);
              }else{
                setSalesOrganization(res.array);
            }
            }.bind(this)
          )
          .catch(function(error) {          
          console.log(error);
          
          });            
        
          authGetCustomerDetails(JSON.stringify(data)).then(function(response) {
          var res = response.data;
            if(res.status=='true' && res.code=='200')
            {
             var data = res.array
             var filtered = data.filter((x)=>{return x.value===distributionChannel})
             setDiscChannel(filtered);
              setDistributionChannel(res.array);
            }else{
              setDistributionChannel(res.array);
          }
          }.bind(this)
      )
      .catch(function(error) {   
        console.log(error);    
      });
      
      authGetCustomerDetails(JSON.stringify(division_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array
             var filtered = data.filter((x)=>{return x.value===division})
             setDivitionEdited(filtered);
            setDivision(res.array);
          }else{
            setDivision(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      
      });
      authGetCustomerDetails(JSON.stringify(goods_tax_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array;
            var filtered = data.filter((x)=>{return x.value===tax_classification5})
            setgoodtaxEdited(filtered);
            setGoodsTAX(res.array);
          }else{
            setGoodsTAX(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      authGetCustomerDetails(JSON.stringify(region_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array
             var filtered = data.filter((x)=>{return x.value===region})
             setRegionEdited(filtered);
            Setregion(res.array);
          }else{
            Setregion(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(recon_account_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
             var data = res.array
             var filtered = data.filter((x)=>{return x.value===recon_account})
             setReconAccountEdited(filtered);
            setReaconAccount(res.array);
          }else{
            setReaconAccount(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(terms_of_payment_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            setTermsPayment(res.array);
          }else{
            setTermsPayment(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(sales_district_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array
             var filtered = data.filter((x)=>{return x.value===sales_district})
             setSalesDistrictValueEdited(filtered);
            setSalesDistrict(res.array);
          }else{
            setSalesDistrict(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(company_code_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array 
             var filtered = data.filter((x)=>{return x.value===companyCode})
            
             setcomCode(filtered);
            setCompanyCode(res.array);
          }else{
            setCompanyCode(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(sales_office_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array;
             var filtered = data.filter((x)=>{return x.value===sales_office})
             setSalesOfficeValueEdited(filtered);
            setSalesOffice(res.array);
          }else{
            setSalesOffice(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(shipping_condition_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array;
            var filtered = data.filter((x)=>{return x.value===shipping_condition})
            setShippingConsitionEdited(filtered);
            setShippingCon(res.array);
          }else{
            setShippingCon(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      
      authGetCustomerDetails(JSON.stringify(industry_code_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array;
            var filtered = data.filter((x)=>{return x.value===industry_code1})
            setIndustryCodeEdited(filtered);
            setIndustryCode(res.array);
          }else{
            setIndustryCode(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);
      });
      authGetCustomerDetails(JSON.stringify(group_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array 
           var filtered = data.filter((x)=>{return x.value===customerAccGrp})
          
           setAccGroup(filtered);
            setAccountGroup(res.array);
          }else{
            setAccountGroup(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {
      console.log(error);        
      });     
      authGetCustomerDetails(JSON.stringify(account_assignment_group_data)).then(function(response) {
        var res = response.data;
          if(res.status=='true' && res.code=='200')
          {
            var data = res.array;
            var filtered = data.filter((x)=>{return x.value===account_assignment_group})
            setaccountAssignemntEdited(filtered);
            setAccountAssignmentGroup(res.array);
          }else{
            setAccountAssignmentGroup(res.array);
        }
        }.bind(this)
      )
      .catch(function(error) {    
      console.log(error);
      });
        }else{
          setCustomerDetails(res.customer_details);
          setApproval(res.approval_status);
      }
      }.bind(this)
    )
    .catch(function(error) {
    console.log(error);
    });
   
    if((status=='Pending') && (user_type=='Lev-1' || user_type=='Lev-2'))
    {
      setLgShow(true);
    }else if(status=='Approved' && (user_type=='Lev-1' || user_type=='Lev-2'))
    {
      setlgApproveShow(true);
    }else if(status=='Rejected' && (user_type=='Lev-1' || user_type=='Lev-2'))
    {
      setlgApproveShow(true);
    }else if((status=='Approved' || status=='Pending')&& initiator_status!='Rejected' && (user_type=='initiator' || user_type=='superadmin'))
    {
      
      setLgShow(true);
    }else if(status=='Closed' && user_type=='support')
    {
      
      setLgShow(true);
    }else if(initiator_status=='Rejected' && (user_type=='initiator' || user_type=='superadmin'))
    {
      
      setEditLgShow(true);
    }else{

    }
  }
  const fetchFilterData3 = async (e) => {
   
    setLoaderSpinner(true);
    const data = {
      "action": 'getCustomer',
      "userid" : userID,
      "user_id" : userid,
      "user_type" : userAccess
    };
   //console.log(JSON.stringify(data));
    authGetCustomer(JSON.stringify(data)).then(function(response) {
    var res = response.data;
   
      if(res.status=='true' && res.code=='200')
      {
        setLoaderSpinner(false);
        var resdata = res.customer_details;
        
        var text = "select * from ? WHERE status = ?";
        var arraydata = alasql(text,[resdata,statusSort]);
        setCurrentCustomerList(arraydata);
        setNofopage(Math.ceil(arraydata.length / offset));
        var text1 = "select * from ? LIMIT " + offset + " OFFSET " + (curpage - 1) * offset;          
        var arraydata1 = alasql(text1, [arraydata]);
        //console.log(arraydata1);
        setTotalCount(arraydata.length);
        setCustomerList(arraydata1);
      }else{
        setTotalCount(res.count);
        setCustomerList(res.customer_details);
    }
    }.bind(this)
  )
  .catch(function(error) {
  console.log(error);
  });
  };
  const handleStatusSort = async (event) => {  
    setStatusSort(event.value);
    setSortStatusValue([{ value: event.value, label: event.value }]);
    setCusAcctGrpValue([{ value: '', label: 'Customer Account Group' }]);

  }
  const handleName1Change = async (event) => {
    setselectName1(event.target.value);
    setselectName3(event.target.value);
    setselectSerachTerm(event.target.value);
    setselectComment(event.target.value);
  }
  const handleName2Change = async (event) => {
    setselectName2(event.target.value);
  }
  const handleName3Change = async (event) => {
    setselectName3(event.target.value);
  }
  const handleName4Change = async (event) => {
    setselectName4(event.target.value);
  }
  const handleChangeSearchTerm = async (event) => {
    setselectSerachTerm(event.target.value);
  }
  const handleChangeStreet2 = async (event) => {
    setselectStreet2(event.target.value);
  }
  const handleChangeStreet3 = async (event) => {
    setselectStreet3(event.target.value);
  }
  const handleChangePostalCode = async (event) => {
    setselectPostalCode(event.target.value);
    var postal_code = event.target.value;

    const data = {
      "action": 'geo_mapping',
      "postal_code": postal_code
    };

     //console.log(data);
     authGeoMapping(JSON.stringify(data)).then(function (response) {
      var res = response.data;
     
      if (res.status == 'true' && res.code == '200') {
        setCity1(res.city);
        setCity2(res.district);
        setStreet(res.street);
      } else {

      }
    }.bind(this)
    )
      .catch(function (error) {
        setLoader(false)
        console.log(error);

      });

  }
  const handleChangeCity = async (event) => {
    setCityValue(event.value);
    var cityValue = [
      { value: event.value, label: event.value }
    ];
    setCity1(cityValue);
  }
  const handleChangeDistrict = async (event) => {
    setDistrictValue(event.value);
    var districtValue = [
      { value: event.value, label: event.value }
    ];
    setCity2(districtValue);
  }
  const handleChangeStreet = async (event) => {
    setseletStreet(event.value);
    var streetValue = [
      { value: event.value, label: event.value }
    ];
    setStreet(streetValue);
  }
  const handleChangeTelephone = async (event) => {
    setselectTelephone(event.target.value);
  }
  const handleChangeMobile = async (event) => {
    setselectMobile(event.target.value);
  }
  const handleChangeFAX = async (event) => {
    setselectFAX(event.target.value);
  }
  const handleChangeEmail = async (event) => {
    setselectEmail(event.target.value);
  }
  const handleChangePAN = async (event) => {
    setselectPAN(event.target.value);
  }
  const handleChangePANReference = async (event) => {
    setselectPANReference(event.target.value);
  }
  const handleChangeGST = async (event) => {
    setselectGSTN(event.target.value);
  }
  const handleChangeIndustryKey = async (event) => {
    setselectIndustryKey(event.target.value);
  }
  const handleChangeVendorCode = async (event) => {
    setselectVendorCode(event.target.value);
  }
  const handleChangeEP = async (event) => {
    setselectEP(event.target.value);
  }
  const handleChangeIP = async (event) => {
    setselectIP(event.target.value);
  }
  const handleOnChange = async (event) => {
    var data = accountGroup 
             var filtered = data.filter((x)=>{return x.value===event.value})
             setAccGroup(filtered);
    setSelectedAccountGroup(event.value);
  }
  const handleOnChangeRegion = async (event) => {
    var data = region; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setRegionEdited(filtered);
    setRegionValue(event.value);
  }
  const handleOnChangeCompanyCode = async (event) => {
    var data = companyCode; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setcomCode(filtered);
    setSelectedCompanyCode(event.value);
  }
  const handleOnChangeTerritoryCode = async (event) => {
    var industryCodeValue = [
      { value: event.value, label: event.value }
    ];
    setTerritoryCode(industryCodeValue);
    setselectIndustryCode(event.value);
  }
  const handleOnChangeSalesOrg = async (event) => {
    var data = salesOrganization; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setSalesOrg(filtered);
    setSelectSalesOrganization(event.value);
  }
  const handleChangeShippingCondition = async (event) => {
    var data = shippingCon; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setSalesOrg(filtered);
    setselectShippingCondition(event.value);
  }
  const handleChangeAccAssignment = async (event) => {
    var data = accountAssignmentGroup; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setaccountAssignemntEdited(filtered);
    setselectAssignmentGroup(event.value);
  }
  const handleOnChangeDistributionChannel = async (event) => {
    var data = distributionChannel; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setDiscChannel(filtered);
    setselectDistributionChannel(event.value);
  }
  const handleOnChangeFranchiseType = async (event) => {
    var franchiseTypeValue = [
      { value: event.value, label: event.value }
    ];
    setfranchiseTypeSelect(franchiseTypeValue);
    setfranchiseType(event.value);
  }
  const handleChangePaymentKey = async (event) => {
    var paymentkeyvalue = [
      { value: event.value, label: event.value }
    ];
    setpaymentkey(paymentkeyvalue);
    setPaymentKeyValue(event.value);
  }
  const handleChangeAttribute1 = async (event) => {
    var attribute1Options = [
      { value: event.value, label: event.value }
    ];
    setattribute1Options(attribute1Options);
    setAttribute1Value(event.value);
  }
  const handleChangeAttribute2 = async (event) => {
    var attribute2Options = [
      { value: event.value, label: event.value }
    ];
    setattribute2Options(attribute2Options);
    setAttribute2Value(event.value);
  }
  const handleChangeIncoterms1 = async (event) => {
    var incoterms1value = [
      { value: event.value, label: event.value }
    ];
    setincoterms1(incoterms1value);
    setIncoterms1Value(event.value);
  }
  const handleChangeIncoterms2 = async (event) => {
    var incoterms2value = [
      { value: event.value, label: event.value }
    ];
    setincoterms2(incoterms2value);
    setIncoterms2Value(event.value);
  }
  const handleChangeTAX1 = async (event) => {
    var trax_classification1 = [
      { value: event.value, label: event.value }
    ];
    settaxClassification1Option(trax_classification1);
    setTaxCollection1(event.value);
  }
  const handleChangeTAX2 = async (event) => {
    var trax_classification2 = [
      { value: event.value, label: event.value }
    ];
    settaxClassification2Option(trax_classification2);
    setTaxCollection2(event.value);
  }
  const handleChangeTAX3 = async (event) => {
    var trax_classification3 = [
      { value: event.value, label: event.value }
    ];
    settaxClassification3Option(trax_classification3);
    setTaxCollection3(event.value);
  }
  const handleChangeTAX4 = async (event) => {
    var trax_classification4 = [
      { value: event.value, label: event.value }
    ];
    settaxClassification4Option(trax_classification4);
    setTaxCollection4(event.value);
  }
  const handleChangeTAX6 = async (event) => {
    var trax_classification6 = [
      { value: event.value, label: event.value }
    ];           
    settaxClassification6Option(trax_classification6);
    setTaxCollection6(event.value); 
  }
  const handleOnChangeAccountGroupFilter = async (event) => {
    setSearch2(event.value);
    setCusAcctGrpValue([{ value: event.value, label: event.value }]);
    setSortStatusValue([{ value: '', label: 'Choose Status' }]);
  }
  const handleOnChangeDivision = async (event) => {
    var data = division; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setDivitionEdited(filtered);
    setSelectDivition(event.value);
  }
  const handleGoodTAX = async (event) => {
    var data = goodstax; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setgoodtaxEdited(filtered);
    setSelectGoodTAX(event.value);
   
  }
  const handleOnChangeReconAccount = async (event) => {
    var data = reaconAccount; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setReconAccountEdited(filtered);
    setSelectReconAccount(event.value);
  }
  const handleOnChangeSalesDistrict = async (event) => {
    var data = salesDistrict; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setSalesDistrictValueEdited(filtered);
    setSelectsalesDistrict(event.value);
   
  }
  const handleOnChangeSalesGroup = async (event) => {
    var data = salesGroup; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setsalesGrp(filtered);
    setSalesGroupValue(event.value);
  }
  const handleOnChangeSalesOffice = async (event) => {
    var data = salesOffice; 
    var filtered = data.filter((x)=>{return x.value===event.value})
    setSalesOfficeValueEdited(filtered);
    setSelectSalesOffice(event.value);
    let sales_office = event.value;
    const data1 = {
      "action": 'sales_office_group_mapping',
      "sales_office": sales_office
    };

    authSalesOfficeGroupMapping(JSON.stringify(data1)).then(function (response) {
      var res = response.data;
      if (res.status == 'true' && res.code == '200') {
        setSalesGroup(res.array);
      } else {
        setSalesGroup(res.array);
      }
    }.bind(this)
    )
      .catch(function (error) {
        setLoader(false)
        console.log(error);

      });
  }
  const exportToExcelAll =  async () => {
    let fileName = 'customerData';
    const ExcelExportData = currentCustomerList;
            const ws = XLSX.utils.json_to_sheet(ExcelExportData);
            const wb = {Sheets:{'data': ws}, SheetNames: ['data']};
            const excelBuffer = XLSX.write(wb, {bookType:'xlsx', type:'array'});
            const data = new Blob([excelBuffer], {type:fileType});
            FileSaver.saveAs(data, fileName + fileExtension);
  
   
  }
  return (  
    <DashboardLayout> 
      <DashboardNavbar />
      <ToastContainer />
      {userAccess=='superadmin' || userAccess=='Lev-1' || userAccess=='Lev-2' || userAccess=='initiator' || userAccess=='support'  ?
      <SoftBox py={3}>
      <Table striped bordered hover size="sm" style={{ fontSize: 10 }}>
      <tbody>
      <tr>
       <td colSpan="3" style={{ fontSize: 15 }}>Filter <span style={{ fontSize: 12 }}>(*Choose any one filter at a time)</span></td> 
      </tr>  
      <tr>
      <td>
      <SoftBox mb={2} style={{ display: "flex", flexDirection: "row" }}>
        <SoftBox mr={2} ml={0}>
          <SoftInput
            type="text"
            placeholder="Search by Request ID."
            style={{ width: "200px" }}
            value={search}
            size="small"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </SoftBox>

        <SoftButton
          onClick={(e) => filterData(e)}
          variant="gradient"
          color="info"
          size="small"
        >
          Search
        </SoftButton>
      </SoftBox>  
      </td>
      <td>
      <SoftBox mb={2} style={{ display: "flex", flexDirection: "row" }}>
        <SoftBox mr={2} ml={0}>
        <SoftSelect
          name="account_group_filter"
          id="account_group_filter"
          placeholder="Customer Account Group"
          defaultValue={search2}
          size="small"
          value={cusAcctGrpValue}
          options={[
            { value: "Z011", label: "Z011-Marketing sold to party" },
            { value: "Z012", label: "Z012-Mkt / Ser. Ship to party" },
            { value: "Z031", label: "Z031-Service sold to party"},
            { value: "Z015", label: "Z015-Mkt / Ser. Sold to Party- Tufftech/Bommasandra"}
          ]}
          onChange={handleOnChangeAccountGroupFilter}             
        />
        </SoftBox>

        <SoftButton
          onClick={(e) => filterData2(e)}
          variant="gradient"
          color="info"
          size="small"
        >
          Search
        </SoftButton>
      </SoftBox>  
      </td>
      <td>
      <SoftBox mb={2} style={{ display: "flex", flexDirection: "row" }}>
        <SoftBox mr={2} ml={0}>
        <SoftSelect
          name="status_sort"
          id="status_sort"
          placeholder="Choose Status"
          onChange={handleStatusSort}
          size="small"
          value={sortStatusValue}
          options={[
            { value: "Approved", label: "Approved" }, 
            { value: "Pending", label: "Pending" },
            { value: "Closed", label: "Closed" }
          ]}
        />
        </SoftBox>

        <SoftButton
          onClick={(e) => filterData3(e)}
          variant="gradient"
          color="info"
          size="small"
        >
          Search</SoftButton>
      </SoftBox>  
      </td>  
      </tr>   
        </tbody>
      </Table>
      <Table striped hover size="sm" style={{ fontSize: 12}}>
      <tr>
      <td>Total Count: {totalCount}</td>
      <td colSpan="2" style={{ textAlign: 'right'}}>
      <SoftButton
          variant="gradient"
          color="warning"
          size="small"
          onClick={(e)=>exportToExcelAll()}
        >
          Export to Excel
        </SoftButton>
      </td>
      </tr>  
      </Table>
      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
      <thead>
        <tr style={{color : "white",backgroundColor: "#3498db"}}>     
          <th>Request ID</th>
          <th>SAP Customer Code</th>     
          <th>Name</th>
          <th>Account Group</th>
          <th>GSTN</th>
          <th>PAN</th>
          <th>Request Creation At</th>
          {userAccess=='initiator'?<th>Approval Tracking</th>: null}
          <th>Status</th>
          <th>Request Closure At</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
      {customerlist.map((item, idx) => {
        return <tr key={idx}>
          <td>{item.customer_number}</td>
          <td>{item.sap_customer_no}</td>       
          <td>{item.name1}</td>
          <td>{item.customer_account_group}</td>
          <td>{item.gstn}</td>
          <td>{item.pan}</td>
          <td>{item.created_at}</td>
          {userAccess=='initiator'?<td>{item.approver.map((item,idx1)=><div key={idx1}><div><strong>{item.approver_name}</strong>-{item.status=='Approved'?<SoftBadge className="app_class" variant="contained" color="success" badgeContent={item.status} container />:<SoftBadge variant="contained" color="warning" badgeContent={item.status} container /> }</div></div>)}</td>: null}
          <td>{item.status=='Approved'?
          <SoftBadge variant="contained" color="success" className="app_class" badgeContent={item.status} container /> 
          : item.status=='Rejected'?
          <SoftBadge variant="contained" color="failed" badgeContent={item.status} container /> 
          :
          <SoftBadge variant="contained" color="warning" badgeContent={item.status} container />}
          </td>
          <td>{item.updated_at=='0'?'' : item.updated_at}</td>
          {(userAccess=='Lev-1' || userAccess=='Lev-2') ? 
          <td>
            {item.status=='Pending'?
          <div style={{ width: '100%'}}>

            <div style={{ width: '33.33%'}}>
          <SoftBox>
          <SoftButton variant="text" color="primary" onClick={()=>{viewCustomerDetails(item.id,item.status,userAccess,item.initiator_status)}}>
                <Icon>visibility</Icon>
              </SoftButton>   
            </SoftBox>
            </div>           
            <div style={{ width: '33.33%'}}>
            <SoftBox>
          <SoftButton variant="text" color="success" onClick={()=>{approveHandle(item.id,item.distribution_channel,'Approved')}}>
                <Icon>done</Icon>
              </SoftButton>   
            </SoftBox>
            </div>
            <div style={{ width: '33.33%'}}>
            <SoftBox>
          <SoftButton variant="text" color="error" onClick={()=>{approveHandle(item.id,item.distribution_channel,'Rejected')}}>
                <Icon>clear</Icon>
              </SoftButton>   
            </SoftBox>
            </div>
        
          </div> 
          : <Grid container key={idx} spacing={1} lineHeight={1}>

          <Grid item xs={12} md={3}>
        <SoftBox>
        <SoftButton variant="text" color="primary" onClick={()=>{viewCustomerDetails(item.id,item.status,userAccess,item.initiator_status)}}>
              <Icon>visibility</Icon>
            </SoftButton>   
          </SoftBox>
          </Grid>           
        </Grid> } 

          <Modal
        size="fullscreen-xxl-down"
        show={lgShow}
        onHide={() => setLgShow(false)} 
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Customer Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>        
        <Table striped bordered hover style={{ fontSize: 11 }}>
  
        <tbody>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Company Details</strong></td>
          </tr>
          <tr>
            <td><strong>Company Code</strong></td>
            <td>{customerDetails.company_code}</td>
            <td><strong>Sales Organization</strong></td>
            <td>{customerDetails.sales_organization}</td>
          </tr>
          <tr>
          <td><strong>Distribution Channel</strong></td>
            <td>{customerDetails.distribution_channel}</td>
            <td><strong>Division</strong></td>
            <td>{customerDetails.division}</td>  
          </tr>
          <tr>
            <td><strong>Customer Account Group</strong></td>
            <td>{customerDetails.customer_account_group}</td>
            <td><strong>Reconciliation Account in General Ledger</strong></td>
            <td>{customerDetails.general_ledger}</td>
          </tr>
          {customerDetails.customer_account_group=='Z031'?
          <tr>
            <td><strong>Franchise Type</strong></td>
            <td>{customerDetails.franchise_type}</td>
            <td></td>
            <td></td>
          </tr>
          : null}
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Personal Details</strong></td>
          </tr>
          <tr>
            <td><strong>Name 1</strong></td>
            <td>{customerDetails.name1}</td>
            <td><strong>Name 2</strong></td>
            <td>{customerDetails.name2}</td>          
          </tr>
          <tr>
          <td><strong>Name 3</strong></td>
            <td>{customerDetails.name3}</td>
            <td><strong>Name 4</strong></td>
            <td>{customerDetails.name4}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Contact Details</strong></td>
          </tr>
          <tr>
            <td><strong>Search Term 1</strong></td>
            <td>{customerDetails.search_term1}</td>
            <td><strong>Street</strong></td>
            <td>{customerDetails.street}</td>
          </tr>
          <tr>
          <td><strong>Street 2</strong></td>
            <td>{customerDetails.street1}</td>
            <td><strong>Street 3</strong></td>
            <td>{customerDetails.street2}</td>
          </tr>
          <tr>
          <td><strong>City Postal Code</strong></td>
            <td>{customerDetails.postal_code}</td>
            <td><strong>District</strong></td>
            <td>{customerDetails.district}</td> 
          </tr>
          <tr>
          <td><strong>City</strong></td>
            <td>{customerDetails.city}</td>
            <td><strong>Country Key</strong></td>
            <td>{customerDetails.country}</td>
          </tr>
          <tr>
            <td><strong>Region</strong></td>
            <td>{customerDetails.region}</td>
            <td><strong>Language Key</strong></td>
            <td>{customerDetails.language}</td>
          </tr>
          <tr>
          <td><strong>Telephone No</strong></td>
            <td>{customerDetails.telephone}</td>
            <td><strong>Mobile No</strong></td>
            <td>{customerDetails.mobile}</td>
          </tr>
          <tr>
            <td><strong>Fax No</strong></td>
            <td>{customerDetails.fax}</td>
            <td><strong>E-Mail</strong></td>
            <td>{customerDetails.email}</td>
          </tr>
          <tr>
          <td><strong>Attribute 1</strong></td>
            <td>{customerDetails.attribute1}</td>
            <td><strong>Attribute 3</strong></td>
            <td>{customerDetails.attribute2}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>GSTN,PAN & Other Details</strong></td>
          </tr>
          <tr>
            <td><strong>PAN</strong></td>
            <td>{customerDetails.pan}</td>
            <td><strong>PAN Reference</strong></td>
            <td>{customerDetails.pan_reference}</td>
          </tr>
          <tr>
          <td><strong>GSTN</strong></td>
            <td>{customerDetails.gstn}</td>
            <td><strong>Industry key</strong></td>
            <td>{customerDetails.industry_key}</td>
          </tr>
          <tr>
          <td><strong>Territory Code</strong></td>
            <td>{customerDetails.industry_code1}</td>
            <td><strong>PAN Document</strong></td>
            <td>
           
             {PANFiles.map((item, idx) => {
             return  <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })} 
            </td>
          </tr>
          <tr>
          <td><strong>GSTN Document</strong></td>
            <td>
            {GSTNFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
            <td><strong>Other Document</strong></td>
            <td>
            {OtherFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
          </tr>
          <tr>
            <td><strong>MSME No.</strong></td>
            <td>{customerDetails.tax_number_five}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Other Details</strong></td>
          </tr>       
          <tr>
            <td><strong>Sales District</strong></td>
            <td>{customerDetails.sales_district}</td>
            <td><strong>Sales Office</strong></td>
            <td>{customerDetails.sales_office}</td>
          </tr>
          <tr>
          <td><strong>Sales Group</strong></td>
            <td>{customerDetails.sales_group}</td>
            <td><strong>Pricing procedure assigned to this customer</strong></td>
            <td>{customerDetails.pricing_procedure}</td>
          </tr>
          <tr>
          
            <td><strong>Customer Statistics Group</strong></td>
            <td>{customerDetails.customer_statistic_group}</td>
            <td><strong>Shipping Conditions</strong></td>
            <td>{customerDetails.shipping_condition}</td>
          </tr>
          <tr>
          <td><strong>Indicator</strong></td>
            <td>{customerDetails.indicator}</td>
            <td><strong>Account assignment group for this customer</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td><strong>Incoterms (Part 1)</strong></td>
            <td>{customerDetails.incoterms1}</td>
            <td><strong>Incoterms (Part 2)</strong></td>
            <td>{customerDetails.incoterms2}</td>
          </tr>
          <tr>
          <td><strong>Terms of Payment Key</strong></td>
            <td>{customerDetails.payment_key}</td>
            <td><strong>Credit Control Area</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td colSpan={8} style={{ color: 'blue', fontSize : '18px'}}><strong>Withholding Details</strong></td>
          </tr>
          <tr>
            <td><strong>Central GST - OP</strong></td>
            <td>{customerDetails.tax_classification1}</td>
            <td><strong>Integrated GST</strong></td>
            <td>{customerDetails.tax_classification2}</td>
          </tr>
          <tr>
          <td><strong>State GST – OP</strong></td>
            <td>{customerDetails.tax_classification3}</td>
            <td><strong>Union Ter. GST-OP</strong></td>
            <td>{customerDetails.tax_classification4}</td>
          </tr>
          <tr>
            <td><strong>IN 206C(1H) Goods</strong></td>
            <td>{customerDetails.tax_classification5}</td>
            <td><strong>Tax Collected At Source</strong></td>
            <td>{customerDetails.tax_classification6}</td>
            
          </tr>
         
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Partner Function Details</strong></td>
          </tr>
          <tr>
            <td><strong>EP</strong></td>
            <td>
            {customerDetails.ep}
            </td>
            <td><strong>IP</strong></td>
            <td>
            {customerDetails.ip}
            </td>
          </tr>
          <tr>
            <td><strong>Sold To Party</strong></td>
            <td>{customerDetails.sold_to_party}</td>
            <td><strong>Customer Group</strong></td>
            <td>{customerDetails.customer_group}</td>
          </tr>
          {item.status=='Pending'?
          <tr>
            <td>
            <SoftBox mt={3} mb={1}>
          <SoftButton variant="gradient" color="success" fullWidth onClick={()=>{approveHandle(customerDetails.id,customerDetails.distribution_channel,'Approved')}}>
           Approve
          </SoftButton>
        </SoftBox>
            </td>
            <td>
            <SoftBox mt={3} mb={1}>
          <SoftButton variant="gradient" color="warning" fullWidth onClick={()=>{approveHandle(customerDetails.id,customerDetails.distribution_channel,'Rejected')}}>
           Reject
          </SoftButton>
        </SoftBox>
            </td>
            <td>
            </td>
            <td>
            </td>
            
          </tr>
          : null}
        </tbody>
          </Table>
        </Modal.Body>
          </Modal>

          <Modal
        size="fullscreen-xxl-down"
        show={lgApproveShow}
        onHide={() => setlgApproveShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Customer Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>        
        <Table striped bordered hover style={{ fontSize: 11 }}>
  
        <tbody>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Company Details</strong></td>
          </tr>
          <tr>
            <td><strong>Company Code</strong></td>
            <td>{customerDetails.company_code}</td>
            <td><strong>Sales Organization</strong></td>
            <td>{customerDetails.sales_organization}</td>
          </tr>
          <tr>
          <td><strong>Distribution Channel</strong></td>
            <td>{customerDetails.distribution_channel}</td>
            <td><strong>Division</strong></td>
            <td>{customerDetails.division}</td>  
          </tr>
          <tr>
            <td><strong>Customer Account Group</strong></td>
            <td>{customerDetails.customer_account_group}</td>
            <td><strong>Reconciliation Account in General Ledger</strong></td>
            <td>{customerDetails.general_ledger}</td>
          </tr>
          {customerDetails.customer_account_group=='Z031'?
          <tr>
            <td><strong>Franchise Type</strong></td>
            <td>{customerDetails.franchise_type}</td>
            <td></td>
            <td></td>
          </tr>
          : null}
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Personal Details</strong></td>
          </tr>
          <tr>
            <td><strong>Name 1</strong></td>
            <td>{customerDetails.name1}</td>
            <td><strong>Name 2</strong></td>
            <td>{customerDetails.name2}</td>          
          </tr>
          <tr>
          <td><strong>Name 3</strong></td>
            <td>{customerDetails.name3}</td>
            <td><strong>Name 4</strong></td>
            <td>{customerDetails.name4}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Contact Details</strong></td>
          </tr>
          <tr>
            <td><strong>Search Term 1</strong></td>
            <td>{customerDetails.search_term1}</td>
            <td><strong>Street</strong></td>
            <td>{customerDetails.street}</td>
          </tr>
          <tr>
          <td><strong>Street 2</strong></td>
            <td>{customerDetails.street1}</td>
            <td><strong>Street 3</strong></td>
            <td>{customerDetails.street2}</td>
          </tr>
          <tr>
          <td><strong>City Postal Code</strong></td>
            <td>{customerDetails.postal_code}</td>
            <td><strong>District</strong></td>
            <td>{customerDetails.district}</td> 
          </tr>
          <tr>
          <td><strong>City</strong></td>
            <td>{customerDetails.city}</td>
            <td><strong>Country Key</strong></td>
            <td>{customerDetails.country}</td>
          </tr>
          <tr>
            <td><strong>Region</strong></td>
            <td>{customerDetails.region}</td>
            <td><strong>Language Key</strong></td>
            <td>{customerDetails.language}</td>
          </tr>
          <tr>
          <td><strong>Telephone No</strong></td>
            <td>{customerDetails.telephone}</td>
            <td><strong>Mobile No</strong></td>
            <td>{customerDetails.mobile}</td>
          </tr>
          <tr>
            <td><strong>Fax No</strong></td>
            <td>{customerDetails.fax}</td>
            <td><strong>E-Mail</strong></td>
            <td>{customerDetails.email}</td>
          </tr>
          <tr>
          <td><strong>Attribute 1</strong></td>
            <td>{customerDetails.attribute1}</td>
            <td><strong>Attribute 3</strong></td>
            <td>{customerDetails.attribute2}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>GSTN,PAN & Other Details</strong></td>
          </tr>
          <tr>
            <td><strong>PAN</strong></td>
            <td>{customerDetails.pan}</td>
            <td><strong>PAN Reference</strong></td>
            <td>{customerDetails.pan_reference}</td>
          </tr>
          <tr>
          <td><strong>GSTN</strong></td>
            <td>{customerDetails.gstn}</td>
            <td><strong>Industry key</strong></td>
            <td>{customerDetails.industry_key}</td>
          </tr>
          <tr>
          <td><strong>Territory Code</strong></td>
            <td>{customerDetails.industry_code1}</td>
            <td><strong>PAN Document</strong></td>
            <td>
           
             {PANFiles.map((item, idx) => {
             return  <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })} 
            </td>
          </tr>
          <tr>
          <td><strong>GSTN Document</strong></td>
            <td>
            {GSTNFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
            <td><strong>Other Document</strong></td>
            <td>
            {OtherFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
          </tr>
          <tr>
            <td><strong>MSME No.</strong></td>
            <td>{customerDetails.tax_number_five}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Other Details</strong></td>
          </tr>       
          <tr>
            <td><strong>Sales District</strong></td>
            <td>{customerDetails.sales_district}</td>
            <td><strong>Sales Office</strong></td>
            <td>{customerDetails.sales_office}</td>
          </tr>
          <tr>
          <td><strong>Sales Group</strong></td>
            <td>{customerDetails.sales_group}</td>
            <td><strong>Pricing procedure assigned to this customer</strong></td>
            <td>{customerDetails.pricing_procedure}</td>
          </tr>
          <tr>
          
            <td><strong>Customer Statistics Group</strong></td>
            <td>{customerDetails.customer_statistic_group}</td>
            <td><strong>Shipping Conditions</strong></td>
            <td>{customerDetails.shipping_condition}</td>
          </tr>
          <tr>
          <td><strong>Indicator</strong></td>
            <td>{customerDetails.indicator}</td>
            <td><strong>Account assignment group for this customer</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td><strong>Incoterms (Part 1)</strong></td>
            <td>{customerDetails.incoterms1}</td>
            <td><strong>Incoterms (Part 2)</strong></td>
            <td>{customerDetails.incoterms2}</td>
          </tr>
          <tr>
          <td><strong>Terms of Payment Key</strong></td>
            <td>{customerDetails.payment_key}</td>
            <td><strong>Credit Control Area</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td colSpan={8} style={{ color: 'blue', fontSize : '18px'}}><strong>Withholding Details</strong></td>
          </tr>
          <tr>
            <td><strong>Central GST - OP</strong></td>
            <td>{customerDetails.tax_classification1}</td>
            <td><strong>Integrated GST</strong></td>
            <td>{customerDetails.tax_classification2}</td>
          </tr>
          <tr>
          <td><strong>State GST – OP</strong></td>
            <td>{customerDetails.tax_classification3}</td>
            <td><strong>Union Ter. GST-OP</strong></td>
            <td>{customerDetails.tax_classification4}</td>
          </tr>
          <tr>
            <td><strong>IN 206C(1H) Goods</strong></td>
            <td>{customerDetails.tax_classification5}</td>
            <td><strong>Tax Collected At Source</strong></td>
            <td>{customerDetails.tax_classification6}</td>
          </tr>
          
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Partner Function Details</strong></td>
          </tr>
          <tr>
            <td><strong>EP</strong></td>
            <td>
            {customerDetails.ep}
            </td>
            <td><strong>IP</strong></td>
            <td>
            {customerDetails.ip}
            </td>
          </tr>
          <tr>
            <td><strong>Sold To Party</strong></td>
            <td>{customerDetails.sold_to_party}</td>
            <td><strong>Customer Group</strong></td>
            <td>{customerDetails.customer_group}</td>
          </tr>
        </tbody>
          </Table>
        </Modal.Body>
          </Modal>
         
          <Modal show={show1} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Customer</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
        <Modal.Body>
          
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address1</Form.Label>
              <Form.Control
                name="email"
                id="email"
                value={userEmail}
                type="email"
                placeholder="name@example.com"
                autoFocus
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Comment</Form.Label>
              <Form.Control as="textarea" rows={3} name="comment" value={state.comment} onChange={handleInputChange} />
            </Form.Group>
          
        </Modal.Body>
        <Modal.Footer>
          
          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Modal.Footer>
        </Form>
          </Modal>
          </td> 
          :
          <td>
          <Grid container key={idx} spacing={3} lineHeight={3}>
            <Grid item xs={12} md={3}>
          <SoftBox>
          <SoftButton variant="text" color="primary" onClick={()=>{viewCustomerDetails(item.id,item.status,userAccess,item.initiator_status)}}>
                <Icon>visibility</Icon>
              </SoftButton>   
            </SoftBox>
            </Grid>
          </Grid>  

          <Modal
        size="fullscreen-xxl-down"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Customer Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>        
        <Table striped bordered hover style={{ fontSize: 11 }}>
  
        <tbody>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Company Details</strong></td>
          </tr>
          <tr>
            <td><strong>Company Code</strong></td>
            <td>{customerDetails.company_code}</td>
            <td><strong>Sales Organization</strong></td>
            <td>{customerDetails.sales_organization}</td>
          </tr>
          <tr>
          <td><strong>Distribution Channel</strong></td>
            <td>{customerDetails.distribution_channel}</td>
            <td><strong>Division</strong></td>
            <td>{customerDetails.division}</td>  
          </tr>
          <tr>
            <td><strong>Customer Account Group</strong></td>
            <td>{customerDetails.customer_account_group}</td>
            <td><strong>Reconciliation Account in General Ledger</strong></td>
            <td>{customerDetails.general_ledger}</td>
          </tr>
          {customerDetails.customer_account_group=='Z031'?
          <tr>
            <td><strong>Franchise Type</strong></td>
            <td>{customerDetails.franchise_type}</td>
            <td></td>
            <td></td>
          </tr>
          : null}
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Personal Details</strong></td>
          </tr>
          <tr>
            <td><strong>Name 1</strong></td>
            <td>{customerDetails.name1}</td>
            <td><strong>Name 2</strong></td>
            <td>{customerDetails.name2}</td>          
          </tr>
          <tr>
          <td><strong>Name 3</strong></td>
            <td>{customerDetails.name3}</td>
            <td><strong>Name 4</strong></td>
            <td>{customerDetails.name4}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Contact Details</strong></td>
          </tr>
          <tr>
            <td><strong>Search Term 1</strong></td>
            <td>{customerDetails.search_term1}</td>
            <td><strong>Street</strong></td>
            <td>{customerDetails.street}</td>
          </tr>
          <tr>
          <td><strong>Street 2</strong></td>
            <td>{customerDetails.street1}</td>
            <td><strong>Street 3</strong></td>
            <td>{customerDetails.street2}</td>
          </tr>
          <tr>
          <td><strong>City Postal Code</strong></td>
            <td>{customerDetails.postal_code}</td>
            <td><strong>District</strong></td>
            <td>{customerDetails.district}</td> 
          </tr>
          <tr>
          <td><strong>City</strong></td>
            <td>{customerDetails.city}</td>
            <td><strong>Country Key</strong></td>
            <td>{customerDetails.country}</td>
          </tr>
          <tr>
            <td><strong>Region</strong></td>
            <td>{customerDetails.region}</td>
            <td><strong>Language Key</strong></td>
            <td>{customerDetails.language}</td>
          </tr>
          <tr>
          <td><strong>Telephone No</strong></td>
            <td>{customerDetails.telephone}</td>
            <td><strong>Mobile No</strong></td>
            <td>{customerDetails.mobile}</td>
          </tr>
          <tr>
            <td><strong>Fax No</strong></td>
            <td>{customerDetails.fax}</td>
            <td><strong>E-Mail</strong></td>
            <td>{customerDetails.email}</td>
          </tr>
          <tr>
          <td><strong>Attribute 1</strong></td>
            <td>{customerDetails.attribute1}</td>
            <td><strong>Attribute 3</strong></td>
            <td>{customerDetails.attribute2}</td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>GSTN,PAN & Other Details</strong></td>
          </tr>
          <tr>
            <td><strong>PAN</strong></td>
            <td>{customerDetails.pan}</td>
            <td><strong>PAN Reference</strong></td>
            <td>{customerDetails.pan_reference}</td>
          </tr>
          <tr>
          <td><strong>GSTN</strong></td>
            <td>{customerDetails.gstn}</td>
            <td><strong>Industry key</strong></td>
            <td>{customerDetails.industry_key}</td>
          </tr>
          <tr>
          <td><strong>Territory Code</strong></td>
            <td>{customerDetails.industry_code1}</td>
            <td><strong>PAN Document</strong></td>
            <td>
           
             {PANFiles.map((item, idx) => {
             return  <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })} 
            </td>
          </tr>
          <tr>
          <td><strong>GSTN Document</strong></td>
            <td>
            {GSTNFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
            <td><strong>Other Document</strong></td>
            <td>
            {OtherFiles.map((item, idx) => {
              return <div key={idx}>
                <a href={item.filepath}>{item.filename}</a>
              </div>
            })}
            </td>
          </tr>
          <tr>
            <td><strong>MSME No.</strong></td>
            <td>{customerDetails.tax_number_five}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Other Details</strong></td>
          </tr>       
          <tr>
            <td><strong>Sales District</strong></td>
            <td>{customerDetails.sales_district}</td>
            <td><strong>Sales Office</strong></td>
            <td>{customerDetails.sales_office}</td>
          </tr>
          <tr>
          <td><strong>Sales Group</strong></td>
            <td>{customerDetails.sales_group}</td>
            <td><strong>Pricing procedure assigned to this customer</strong></td>
            <td>{customerDetails.pricing_procedure}</td>
          </tr>
          <tr>
          
            <td><strong>Customer Statistics Group</strong></td>
            <td>{customerDetails.customer_statistic_group}</td>
            <td><strong>Shipping Conditions</strong></td>
            <td>{customerDetails.shipping_condition}</td>
          </tr>
          <tr>
          <td><strong>Indicator</strong></td>
            <td>{customerDetails.indicator}</td>
            <td><strong>Account assignment group for this customer</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td><strong>Incoterms (Part 1)</strong></td>
            <td>{customerDetails.incoterms1}</td>
            <td><strong>Incoterms (Part 2)</strong></td>
            <td>{customerDetails.incoterms2}</td>
          </tr>
          <tr>
          <td><strong>Terms of Payment Key</strong></td>
            <td>{customerDetails.payment_key}</td>
            <td><strong>Credit Control Area</strong></td>
            <td>{customerDetails.credit_control}</td>
          </tr>
          <tr>
            <td colSpan={8} style={{ color: 'blue', fontSize : '18px'}}><strong>Withholding Details</strong></td>
          </tr>
          <tr>
            <td><strong>Central GST - OP</strong></td>
            <td>{customerDetails.tax_classification1}</td>
            <td><strong>Integrated GST</strong></td>
            <td>{customerDetails.tax_classification2}</td>
          </tr>
          <tr>
          <td><strong>State GST – OP</strong></td>
            <td>{customerDetails.tax_classification3}</td>
            <td><strong>Union Ter. GST-OP</strong></td>
            <td>{customerDetails.tax_classification4}</td>
          </tr>
          <tr>
            <td><strong>IN 206C(1H) Goods</strong></td>
            <td>{customerDetails.tax_classification5}</td>
            <td><strong>Tax Collected At Source</strong></td>
            <td>{customerDetails.tax_classification6}</td>
          </tr>
          
          <tr>
            <td colSpan={4} style={{ color: 'blue', fontSize : '18px'}}><strong>Partner Function Details</strong></td>
          </tr>
          <tr>
            <td><strong>EP</strong></td>
            <td>
            {customerDetails.ep}
            </td>
            <td><strong>IP</strong></td>
            <td>
            {customerDetails.ip}
            </td>
          </tr>
          <tr>
            <td><strong>Sold To Party</strong></td>
            <td>{customerDetails.sold_to_party}</td>
            <td><strong>Customer Group</strong></td>
            <td>{customerDetails.customer_group}</td>
          </tr>
        </tbody>
          </Table>
        </Modal.Body>
          </Modal>

          <Modal
        size="fullscreen-xxl-down"
        show={lgEditShow}
        onHide={() => setEditLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Edit Customer | Request ID : {customerDetails.customer_number}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>        
      
        <Table striped bordered hover style={{ fontSize: 11 }}>
  
  <tbody>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Company Details</strong></td></tr>

    <tr>
    <td><strong>Customer Account Group</strong></td>
      <td>
      <SoftSelect
            name="customer_account_group"
            id="customer_account_group"
            onChange={handleOnChange}
            options={accountGroup}
            value={accGroup}          
          />
      </td>
      <td><strong>Company Code</strong></td>
      <td>
      <SoftSelect
          name="company_code"
          id="company_code"
          options={companyCode}
          onChange={handleOnChangeCompanyCode}
          value={comCode}
        />
      </td>
    </tr>
    <tr>
    <td><strong>Sales Organization</strong></td>
      <td>
      <SoftSelect
          name="sales_organization"
          id="sales_organization"
          options={salesOrganization}
          value={salesOrg}
          onChange={handleOnChangeSalesOrg}                
        />
      </td>
      <td><strong>Distribution Channel</strong></td>
      <td>
      {customerDetails.distribution_channel}
      {/* <SoftSelect
          name="distribution_channel"
          id="distribution_channel"
          options={distributionChannel}
          value={discChannel}
          onChange={handleOnChangeDistributionChannel}                
        /> */
        }
      </td>
    </tr>
    <tr>
    
      <td><strong>Division</strong></td>
      <td>
      <SoftSelect
          name="division"
          id="division"
          options={division}
          value={divitionEdited}
          onChange={handleOnChangeDivision}                 
        />
      </td>
      <td><strong>Reconciliation Account in General Ledger</strong></td>
      <td>
      <SoftSelect
          name="general_ledger"
          id="general_ledger"
          options={reaconAccount}
          value={reconAcc}
          onChange={handleOnChangeReconAccount}
                      
        />
      </td>
    </tr>
    {customerDetails.customer_account_group=='Z031'?
    <tr>
      <td><strong>Franchise Type</strong></td>
      <td>
      <SoftSelect
          name="franchise_type"
          id="franchise_type"
          options={[
            { value: "SMF", label: "SMF-SmallFr" },
            { value: "SFR", label: "SFR-ServiceFr" },
            { value: "RST", label: "RST-RST"},
            { value: "OTH", label: "OTH-Others"},
            { value: "EAF", label: "EAF-ExclACFr"},
            { value: "DFR", label: "DFR-DirectFr"},
            { value: "BFR", label: "BFR-BusFr"},
            { value: "ASD", label: "ASD-AC-SID"},
            { value: "ACS", label: "ACS-AC-SSD"}
          ]}
          value={franchiseTypeSelect}
          onChange={handleOnChangeFranchiseType}             
        />
      </td>
      <td></td>
      <td></td>
    </tr>
    : null }
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Personal Details</strong></td></tr>

    <tr>
    <td><strong>Name 1</strong></td>
      <td>
      <SoftInput
        type="text"
        defaultValue={selectName1}
        placeholder="Name 1"
        size="medium"
        id="name1"
        name="name1"
        onChange={handleName1Change}
        inputProps={{maxLength: "40"}}
        multiline rows={5} />
      </td>
      <td><strong>Name 2</strong></td>
      <td>
      <SoftInput
        type="text"
        placeholder="Name 2"
        defaultValue={selectName2}
        size="medium"
        id="name2"
        name="name2"
        onChange={handleName2Change}
        inputProps={{maxLength: "40"}}
        multiline rows={5} />
      </td>
    </tr>
    <tr>
    <td><strong>Name 3</strong></td>
      <td>
      <SoftInput
        type="text"
        placeholder="Name 3"
        defaultValue={selectName3}
        size="medium"
        id="name3"
        name="name3"
        onChange={handleName3Change}
        inputProps={{maxLength: "40"}}
        multiline rows={5} />
      </td>
      <td><strong>Vendor Code for Customer</strong></td>
      <td>
      <SoftInput
         type="text"
         name="vendor_code"
         id="vendor_code"               
         placeholder="Vendor Code"
         defaultValue={customerDetails.vendor_code}
         onChange={handleChangeVendorCode} 
         size="medium"
         inputProps={{maxLength: "4"}}
         multiline rows={5} 
          />
      </td>
    </tr>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Contact Details</strong></td></tr>

    <tr>
      <td><strong>Search Term 1</strong></td>
      <td>
      <SoftInput 
        type="text" 
        required={true}
        defaultValue={customerDetails.search_term1} 
        name="search_term1" 
        id="search_term1"
        onChange={handleChangeSearchTerm} 
        multiline rows={5} 
        inputProps={{maxLength: "20"}}/>
      </td>
      <td><strong>City Postal Code</strong></td>
      <td>
      <SoftInput 
        type="text"
        defaultValue={customerDetails.postal_code}  
        required={true} 
        id='postal_code'
        size="medium"
        onChange={handleChangePostalCode} 
        multiline rows={5}  />
      </td>
    </tr>
    <tr>
    <td><strong>District</strong></td>
      <td>
      <SoftSelect
          name="district"
          id="district"
          options={city2}
          value={city2}
          onChange={handleChangeDistrict}
        />
      </td>
      <td><strong>Street</strong></td>
      <td>
      <SoftSelect
          name="street"
          id="street"
          options={street}
          value={street}
          onChange={handleChangeStreet}                
        />
      </td>
    </tr>
    <tr>
    
      <td><strong>City</strong></td>
      <td>
      <SoftSelect
          name="city1"
          id="city1"
          options={city1}
          value={city1}
          onChange={handleChangeCity} 
        />
      </td>
      <td><strong>Street 2</strong></td>
      <td>
      <SoftInput 
        type="text"
        name='street2' 
        id='street2' 
        required={true}
        defaultValue={customerDetails.street1}  
        placeholder="Type here..."
        onChange={handleChangeStreet2}  
        multiline rows={5} 
        inputProps={{maxLength: "40"}} />
      </td>
    </tr>

    <tr>
    <td><strong>Street 3</strong></td>
      <td>
      <SoftInput 
        type="text"
        name='street3' 
        id='street3' 
        required={true} 
        placeholder="Type here..."
        onChange={handleChangeStreet3} 
        defaultValue={customerDetails.street2}  
        multiline rows={5} 
        inputProps={{maxLength: "40"}} />
      </td>
      <td><strong>Country Key</strong></td>
      <td>
      <SoftInput
         type="text"
          required={true}
          id="country"
          name="country"
           placeholder="Country"
            size="medium"
             value="IN"
              readOnly />
      </td>
    </tr>
   <tr>
   <td><strong>Region</strong></td>
      <td>
      <SoftSelect
          name="region"                                   
          id="region"
          options={region}
          value={regionEdited}
          onChange={handleOnChangeRegion}
        />
      </td>
      <td><strong>Language Key</strong></td>
      <td>
      <SoftInput 
        type="text"
        id="language"
        name="language"  
        required={true} 
        placeholder="Language Key"
        size="medium"
        value="EN" 
        readOnly />
      </td>
   </tr>
    <tr>
    
      <td><strong>Telephone No</strong></td>
      <td>
      <SoftInput 
        type="text" 
        id= "telephone" 
        name="telephone" 
        placeholder="Telephone"
        defaultValue={customerDetails.telephone} 
        size="medium"
        onChange={handleChangeTelephone} 
        inputProps={{maxLength: "30"}}
        multiline rows={5}  />
      </td>
      <td><strong>Mobile No</strong></td>
      <td>
      <SoftInput 
         type="text"
         name="mobile"
         id="mobile"
         placeholder="Mobile"
         defaultValue={customerDetails.mobile}
         size="medium"
         onChange={handleChangeMobile} 
         inputProps={{maxLength: "30"}}
         multiline rows={5} 
          />
      </td>
    </tr>

    <tr>
      <td><strong>Fax No</strong></td>
      <td>
      <SoftInput 
        type="text"
        defaultValue={customerDetails.fax} 
        id="fax" 
        placeholder="FAX" 
        inputProps={{maxLength: "30"}}
        onChange={handleChangeFAX} 
        multiline rows={5}  />
      </td>
      <td><strong>E-Mail</strong></td>
      <td>
      <SoftInput
        name="email"
        id="email"
        type="email"
        placeholder="Email"
        inputProps={{maxLength: "241"}}
        onChange={handleChangeEmail} 
        defaultValue={customerDetails.email}
        multiline rows={5} 
         />
      </td>
    </tr>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>GSTN,PAN and Other Details</strong></td></tr>
    <tr>
    <td><strong>Attribute 1</strong></td>
      <td>
      <SoftSelect                  
          name="attribute1"
          id="attribute1"
          value={attribute1Options}
          options={[
            { value: "01", label: "01-Tax Invoice" }, 
            { value: "02", label: "01-Non Tax Invoice" },
            { value: "03", label: "03-Internal" },
            { value: "1A", label: "1A-Attribute 1A" },
            { value: "1B", label: "1B-Attribute 1B" }
          ]}
          onChange={handleChangeAttribute1}
          
        />
      </td>
      <td><strong>Attribute 3</strong></td>
      <td>
      <SoftSelect
          name="attribute2"
          id="attribute2"
          value={attribute2Options}
          options={[
            { value: "3A", label: "3A-Attribute 3A" }, 
            { value: "3B", label: "3B-Attribute 3B" },
            { value: "A", label: "A-Cash & Carry" },
            { value: "B", label: "B-PDC Customer" },
            { value: "C", label: "C-Security Cheque" },
            { value: "D", label: "D-Credit" }
          ]}
          onChange={handleChangeAttribute2}
        />
      </td>
    </tr>
   <tr>
   <td><strong>Industry Code</strong></td>
      <td>
      <SoftSelect
          name="industry_code1"
          id="industry_code1"
          value={territoryCode}
          options={industryCode}
          onChange={handleOnChangeTerritoryCode}        
        />
      </td>  
   <td><strong>Industry key</strong></td>
      <td>
      <SoftInput
        type="text"
        name="industry_key"
        id="industry_key"
        placeholder="Industry Key"
        defaultValue={customerDetails.industry_key}
        size="medium"
        onChange={handleChangeIndustryKey} 
        inputProps={{maxLength: "4"}}
        multiline rows={5}  />
      </td>
   </tr>
    <tr>
      <td><strong>PAN</strong></td>
      <td>
      <SoftInput
         type="text"
         required
         name="pan"
         id="pan"
         placeholder="PAN"
         size="medium"
         onChange={handleChangePAN} 
         defaultValue={customerDetails.pan}
        inputProps={{maxLength: "40"}}
        multiline rows={5}  />
      </td>
      <td><strong>PAN Reference</strong></td>
      <td>
      <SoftInput 
        type="text" 
        placeholder="PAN Reference Number" 
        size="medium" 
        multiline rows={5}
        onChange={handleChangePANReference} 
        defaultValue={customerDetails.pan_reference}
        inputProps={{ maxLength: "21" }}  
         />
      </td>
    </tr>
    <tr>
   <td><strong>GSTN</strong></td>
      <td>
      <SoftInput
          type="text"
          name="gstn"
          id="gstn"
          placeholder="GSTN"
          size="medium"
          onChange={handleChangeGST} 
          defaultValue={customerDetails.gstn}
          inputProps={{maxLength: "15"}}
          multiline rows={5} 
              />
      </td>  
   <td>
   <strong>Upload Documents</strong>
   </td>
      <td>
      <div 
      {...getRootProps({ className: "fileDrop" })}>
        <input {...getInputProps()} />
        <img src={Drop} />
        <p className="dragdropbox">
          Drag & Drop or upload documents <br /> (file type: pdf, image, excel, docx)
        </p>
      </div>
      <aside className="fileListBox">
        <ul>{files}</ul>
      </aside>
      </td>
   </tr>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Other Details</strong></td></tr>
    <tr>
      <td><strong>Sales District</strong></td>
      <td>
      <SoftSelect
          name="sales_district"
          id="sales_district"
          options={salesDistrict}
          value={salesDistrictValueEdited}
          onChange={handleOnChangeSalesDistrict}                   
        />
      </td>
      <td><strong>Sales Office</strong></td>
      <td>
      <SoftSelect
          name="sales_office"
          id="sales_office"
          options={salesOffice}
          value={salesOfficeValueEdited}
          onChange={handleOnChangeSalesOffice}                 
        />
      </td>
    </tr>
   
    <tr>
    <td><strong>Sales Group</strong></td>
      <td>
      <SoftSelect
          name="sales_group"
          id="sales_group"
          options={salesGroup}
          value={salesGrp}
          onChange={handleOnChangeSalesGroup} 
        />
      </td>
      <td><strong>Pricing procedure assigned to this customer</strong></td>
      <td>
      <SoftSelect
          name="pricing_procedure"
          id="pricing_procedure"
          options={[
            { value: "1", label: "1" }
          ]}
          value={pricingProcedure}
        />
      </td>
    </tr>
    <tr>
    <td><strong>Customer Statistics Group</strong></td>
      <td>
      <SoftSelect
          name="customer_statistic_group"
          id="customer_statistic_group"
          value={customerStatisticGroup}
          options={[
            { value: "1", label: "1"}
          ]}
          
        />
      </td>
      <td><strong>Shipping Conditions</strong></td>
      <td>
      <SoftSelect
          name="shipping_condition"
          id="shipping_condition"
          options={shippingCon} 
          value={shippingConsitionEdited}
          onChange={handleChangeShippingCondition}               
        />
      </td>
    </tr>
    <tr>
      <td><strong>Incoterms (Part 1)</strong></td>
      <td>
      <SoftSelect
          name="incoterms1"
          id="incoterms1"
          options={[
            { value: "C&F", label: "C&F" },
            { value: "CFR", label: "CFR" },
            { value: "CIF", label: "CIF" },
            { value: "CIP", label: "CIP" },
            { value: "CPT", label: "CPT" },
            { value: "DAF", label: "DAF" },
            { value: "DAP", label: "DAP" },
            { value: "DDP", label: "DDP" },
            { value: "DDU", label: "DDU" },
            { value: "DEQ", label: "DEQ" },
            { value: "DES", label: "DES" },
            { value: "EXI", label: "EXI" },
            { value: "EXW", label: "EXW" },
            { value: "FAS", label: "FAS" },
            { value: "FCA", label: "FCA" },
            { value: "FDN", label: "FDN" },
            { value: "FH", label: "FH" },
            { value: "FOB", label: "FOB" },
            { value: "FOR", label: "FOR" },
            { value: "FYA", label: "FYA" },
            { value: "IDA", label: "IDA" },
            { value: "IMS", label: "IMS" },
            { value: "UN", label: "UN" }
          ]}
          value={incoterms1}
          onChange={handleChangeIncoterms1} 
        />
      </td>
      <td><strong>Incoterms (Part 2)</strong></td>
      <td>
      <SoftSelect
          name="incoterms2"
          id="incoterms2"
          options={[
            { value: "COST & FREIGHT", label: "COST & FREIGHT" },
            { value: "Costs and freight", label: "Costs and freight" },
            { value: "Costs,Insurance and freight", label: "Costs,Insurance and freight" },
            { value: "Carriage and insurance paid to", label: "Carriage and insurance paid to" },
            { value: "Carriage paid to", label: "Carriage paid to" },
            { value: "Delivered at forntier", label: "Delivered at forntier" },
            { value: "Delivered at Place-Verna fact", label: "Delivered at Place-Verna fact" },
            { value: "Delivered Duty Paid", label: "Delivered Duty Paid" },
            { value: "Delivered Duty Unpaid", label: "Delivered Duty Unpaid" },
            { value: "Delivered ex quay(duty paid)", label: "Delivered ex quay(duty paid)" },
            { value: "Delivered ex ship", label: "Delivered ex ship" },
            { value: "Ex Our Works", label: "Ex Our Works" },
            { value: "Ex Your Works", label: "Ex Your Works" },
            { value: "Free alongside ship", label: "Free alongside ship" },
            { value: "Free on Carrier", label: "Free on Carrier" },
            { value: "For Destination", label: "For Destination" },
            { value: "Free house", label: "Free house" },
            { value: "Free on board", label: "Free on board" },
            { value: "F.O.R. Works IFB", label: "F.O.R. Works IFB" },
            { value: "Freight to Your Account", label: "Freight to Your Account" },
            { value: "incl Delivery at above address", label: "inc Delivery at above address" },
            { value: "incl Delivery at supplier place", label: "incl Delivery at supplier place" },
            { value: "Not Free", label: "Not Free" }
          ]}
          onChange={handleChangeIncoterms2} 
          value={incoterms2}
        />
      </td>
    </tr>
    <tr> <td><strong>Indicator</strong></td>
      <td>
      <SoftInput
         type="text"
         name="indicator"
         id="indicator"               
         placeholder="Indicator"
         defaultValue={customerDetails.indicator}
         size="medium"
         inputProps={{maxLength: "1"}}
         readOnly
          />
      </td>
      <td><strong>Account assignment group for this customer</strong></td>
      <td>
      <SoftSelect
          name="account_assignment_group"
          id="account_assignment_group"
          value={accountAssignemntEdited}
          options={accountAssignmentGroup}
          onChange={handleChangeAccAssignment}                   
        />
      </td>
      </tr>
    <tr>
    <td><strong>Terms of Payment Key</strong></td>
      <td>
      <SoftSelect
          name="payment_key" 
          id="payment_key"
          options={termsPayment}
          value={paymentkey}
          onChange={handleChangePaymentKey}                 
        />
      </td>
      <td><strong>Credit Control Area</strong></td>
      <td>
      <SoftSelect
          name="credit_control_area"
          id="credit_control_area"
          options={[
            { value: '1000', label: '1000-HAD General Credit Control' },
            { value: 'Z011', label: 'Z001-HAD-Credit-Additives/Accessories'},
            { value: '3000', label: '3000' },
            { value: 'R011', label: 'R011' }
          ]}
          value={creditControl}
        />
      </td>
      
    </tr>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Withholding Details</strong></td></tr>
    <tr>
    <td><strong>Central GST - OP</strong></td>
      <td>
      <SoftSelect
          name="tax_classification1"
          id="tax_classification1"                  
          options={[
            { value: "0", label: "0 -Taxable under GST" },
            { value: "1", label: "1 -CGST Exempted" },
            { value: "2", label: "2 -Non Taxable CGST" },
            { value: "3", label: "3 -Excisable with GST" },
            { value: "4", label: "4 -Sales Return No Tax" }
          ]}
          value={taxClassification1Option}
          onChange={handleChangeTAX1} 
        />
      </td>
      <td><strong>Integrated GST</strong></td>
      <td>
      <SoftSelect
          name="tax_classification2"
          id="tax_classification2"                  
          options={[
            { value: "0", label: "0 -Taxable under GST" },
            { value: "1", label: "1 -CGST Exempted" },
            { value: "2", label: "2 -Non Taxable CGST" },
            { value: "3", label: "3 -Excisable with GST" },
            { value: "4", label: "4 -Sales Return No Tax" }
          ]}
          value={taxClassification2Option}
          onChange={handleChangeTAX2} 
        />
      </td>
      
    </tr>

    <tr>
    <td><strong>State GST – OP</strong></td>
      <td>
      <SoftSelect
          name="tax_classification3"
          id="tax_classification3"                  
          options={[
            { value: "0", label: "0 -Taxable under GST" },
            { value: "1", label: "1 -CGST Exempted" },
            { value: "2", label: "2 -Non Taxable CGST" },
            { value: "3", label: "3 -Excisable with GST" },
            { value: "4", label: "4 -Sales Return No Tax" }
          ]}
          value={taxClassification3Option}
          onChange={handleChangeTAX3} 
        />
      </td>
    <td><strong>Union Ter. GST-OP</strong></td>
      <td>
      <SoftSelect
          name="tax_classification4"
          id="tax_classification4"                  
          options={[
            { value: "0", label: "0 -Taxable under GST" },
            { value: "1", label: "1 -CGST Exempted" },
            { value: "2", label: "2 -Non Taxable CGST" },
            { value: "3", label: "3 -Excisable with GST" },
            { value: "4", label: "4 -Sales Return No Tax" }
          ]}
          value={taxClassification4Option}
          onChange={handleChangeTAX4} 
        />
      </td>
      
    </tr>
    <tr>
    <td><strong>IN 206C(1H) Goods</strong></td>
      <td>
      <SoftSelect
      name="tax_classification5"
      id="tax_classification5"
      value={goodtaxEdited}
      options={goodstax}
      onChange={handleGoodTAX}   
        />
      </td>
      <td><strong>Tax Collected At Source</strong>
      </td>
      <td>
      <SoftSelect
      name="tax_classification6"
      id="tax_classification6"
      value={taxClassification6Option}
      options={[
        { value: "0", label: "0 -Taxable under GST" },
        { value: "1", label: "1 -CGST Exempted" },
        { value: "2", label: "2 -Non Taxable CGST" },
        { value: "3", label: "3 -Excisable with GST" },
        { value: "4", label: "4 -Sales Return No Tax" }
      ]}
      onChange={handleChangeTAX6}
        />
      </td>
    </tr>
    <tr><td colSpan="4" style={{ color: 'blue', fontSize : '18px'}}><strong>Partner Function Details</strong></td></tr>
    <tr>
      <td><strong>EP</strong></td>
      <td>
      <SoftInput
         type="text"
         name="ep"
         id="ep"               
         placeholder="EP"
         defaultValue={customerDetails.ep}
         size="medium"
         onChange={handleChangeEP}
         inputProps={{maxLength: "4"}}
         multiline rows={5} 
          />
      </td>
      <td><strong>IP</strong></td>
      <td>
      <SoftInput
         type="text"
         name="ip"
         id="ip"               
         placeholder="IP"
         defaultValue={customerDetails.ip}
         size="medium"
         onChange={handleChangeIP}
         inputProps={{maxLength: "20"}}
         multiline rows={5} 
          />
      </td>
      
    </tr>
    <tr>
      <td>
      <SoftBox mt={3} mb={1}>
          <SoftButton variant="gradient" color="success" fullWidth onClick={()=>{updateCustomer(customerDetails.id, customerDetails.customer_number)}}>
           Update Request
          </SoftButton>
        </SoftBox>
      </td>
      <td>{loaderspinner ? <div style={{
                          position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                          zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                        }}>
                          <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                        </div> : ""}</td>
      <td></td>
      <td></td>
    
    </tr>
    
    
  </tbody>
    </Table>

        </Modal.Body>
          </Modal>
          
          </td> 
          
          }      
          </tr>
      })}
        
        
      </tbody>
      </Table>
     
     <Stack spacing={2} style={{ float: "right" }}>
        <Pagination
          count={nofopage}
          showFirstButton
          showLastButton
          page={curpage}
          onChange={(e, page) => setcurPage(page)}
          defaultPage={curpage}
        />
      </Stack>
      {loaderspinner ? <div style={{
                          position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                          zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                        }}>
                          <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                        </div> : ""}
      </SoftBox>
      : 'You do not have the access of this module!'}
    </DashboardLayout>
  );
}
export default CustomerList;